import { Component, OnInit, ViewChild } from '@angular/core';import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from '../../../shared/services/hr/publicSetting';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';

@Component({
  selector: 'app-absence-rule-header-system',
  templateUrl: './absence-rule-header-system.component.html',
  styleUrls: ['./absence-rule-header-system.component.scss']
})
export class AbsenceRuleHeaderSystemComponent implements OnInit {
  button={}
  customDataSource: any;
  
 LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
 currentLang:any;
@ViewChild(DxDataGridComponent) grid:DxDataGridComponent
constructor(public gt:genericCustomStoreService,
  public Objects:ObjectsService,public _publicSettingService:publicSettingService,public router:Router) {
  this._publicSettingService.submit("AbsenceRuleHeaderSystem")
  this.customDataSource =_publicSettingService.customDataSource;  
  this.button=Objects.button;
  this.currentLang = localStorage.getItem(
    this.LOCALIZATION_LOCAL_STORAGE_KEY
  );

}
ngOnInit(): void {
  this._publicSettingService.$ACTIVE_ReFRESH.subscribe(res=>{
  if(res){
  this._publicSettingService.submit("AbsenceRuleHeaderSystem")
  this.customDataSource =this._publicSettingService.customDataSource; 
    }
  })
}

AbsenceHeaderWorkSystem(e:any){            
  this.router.navigate(['hr/add-edit-AbsenceSystem']) 
  this._publicSettingService.$ACTIVE_ID.next(e.key?e.key:0)
}
addrowfun(name:string){
  return this.gt.addrow(name)
}
}

